import { render } from "./OverviewReports.vue?vue&type=template&id=204a7941&scoped=true"
import script from "./OverviewReports.vue?vue&type=script&lang=js"
export * from "./OverviewReports.vue?vue&type=script&lang=js"

import "./OverviewReports.vue?vue&type=style&index=0&id=204a7941&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204a7941"]])

export default __exports__